<!--
 * @Author: your name
 * @Date: 2021-07-12 16:29:48
 * @LastEditTime: 2021-09-13 18:45:31
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\components\templates\allCategoriesDialog.vue
-->
<template>
  <div>
    <el-dialog
     :append-to-body="true"
      title="自定义导航"
      width="600px"
      :visible.sync="dialogVisible"
      @close='closeDialog'>
      <div class="dialog-content">
        <div class="margin-b10">
            <el-button v-if="customCategoriesList.length<8" @click.native.prevent="showDialog('新增')"  type="primary">新增</el-button>
        </div>
       <el-table :data="customCategoriesList"  border height="300px">
        <el-table-column type="index" label="序号" align="center"  width="50"></el-table-column>
        <el-table-column prop="name" label="导航名称" align="center" ></el-table-column>
        <el-table-column prop="linkUrl" label="跳转链接" align="center" ></el-table-column>
        <el-table-column fixed="right" label="操作" align="center"  width="200">
          <template slot-scope="scope">
            <el-button  v-if="scope.row.type==2" @click.native.prevent="showDialog('编辑',scope.row,scope.$index )"  type="text">编辑</el-button>
            <el-button  v-if="scope.row.type==2" @click.native.prevent="deleteRow(scope.$index, customCategoriesList)" type="text">删除</el-button>
            <el-button  v-if="scope.row.type==2" @click.native.prevent="up(scope.$index)" :disabled='scope.$index==3' icon="el-icon-top" type="text">上移</el-button>
            <el-button  v-if="scope.row.type==2" @click.native.prevent="down(scope.$index)" icon="el-icon-bottom" type="text">下移</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="tip-list">
          <p>1.导航名称：不能为空，上限6个字符。（商城首页、全部商品、企业资质为固定导航不可编辑，另可最多维护5个自定义导航）</p>
          <p>2.跳转链接可为空，上限100个字符。</p>
          <p>3.跳转链接请直接从易派客前台相关页面复制，域名开头必须为https://XXXXXX.epec.com。</p>
      </div>
       </div>
        <div slot="footer" class="dialog-footer flex-c">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="sunbmitListData">确 定</el-button>
        </div>
      
    </el-dialog>
  
    
     <!-- 新增/编辑导航 -->
    <el-dialog   :append-to-body="true" :title="dialogTitle" :visible.sync="dialogFormVisible" width="420px">
      <el-form :model="formData" :rules="rules" ref="ruleForm"  label-width="100px">
        <el-form-item label="导航名称:"  prop="name">
          <el-input :disabled='formData.type==1' minlength="2" maxlength="6" v-model.trim="formData.name"></el-input>
        </el-form-item>
        <el-form-item label="跳转链接:">
          <el-input  v-model.trim="formData.linkUrl"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer flex-c">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  <!-- 新增/编辑导航 -->
  </div>
</template>
<script>
 
export default {
   props:{
        activeName: {
            type: String,
            default: ''
        },
         customCategoriesList: {
          type: Array,
          default: function () {
            return []
          }
        },
        
  },
 
  data(){
      return {
          dialogVisible:false,
          dialogTitle:'',
          dialogFormVisible:false,
          formData:{
            name:'',
            linkUrl:'',
            type:2
          },
          rules: {
            name: [
              { required: true, message: '请输入导航名称', trigger: 'change' },
              { min: 2, max: 6, message: '长度在 2 到 6 个字符', trigger: 'change' }
            ]
          },
      }
  },
  watch: {
        activeName(newV,oldV) {
            console.log(newV,oldV)
            this.dialogVisible= newV=='customCategories'?true:false
        } 
},
 
  methods: {
       
    closeDialog(){
        this.$parent.choosenComments('');
    },
    
    sunbmitListData(){
       this.$parent.choosenComments('');
    },

    showDialog(type,row,index){
        this.dialogTitle=type;
        this.dialogFormVisible=true;
        if(type==='编辑'){
          this.activeInde=index;
          this.formData={
            name:row.name,
            linkUrl:row.linkUrl,
            type:row.type,
          }
        }else if(type==='新增'){
          this.formData={
            name:'',
            linkUrl:'',
            type:2,
          }
        }
      },
      deleteRow(index, rows) {
        rows.splice(index, 1);
      },
      up(index) {
            if(index === 0) {
              return
            }
            //在上一项插入该项
            this.customCategoriesList.splice(index - 1, 0, (this.customCategoriesList[index]))
            //删除后一项
            this.customCategoriesList.splice(index + 1, 1)
 
        },
      down(index) {
          if (index === (this.customCategoriesList.length-1)) {
            return
          }
          // 在下一项插入该项
          this.customCategoriesList.splice(index + 2, 0, (this.customCategoriesList[index]))
          // 删除前一项
          this.customCategoriesList.splice(index, 1)
      },
      submitForm(formName){
        
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(this.dialogTitle=='新增'){
              this.customCategoriesList.push(this.formData)
            }else if(this.dialogTitle=='编辑'){
              this.customCategoriesList.splice(this.activeInde, 1, {...this.formData});
            }
            this.dialogFormVisible=false;
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
     
   
 
  }
};
</script>
<style lang="scss" scoped>
@import '../../../../assets/css/theme.scss';
.content-div{
    width:100%;
    padding:10px;
    height:500px;
    border:1px solid #FFA900;;
    margin-top: 10px;
    border-radius: 10px;
    overflow: auto;
    .custom-tree-node{
        width: 100%;
        .label-name{
            line-height: 28px;
        }
        
         .handle-btn{
             float: right;
            align-items: center;
         }
    }
}
.tag-btn{
  margin-right: 10px;
}
.tip-list{
  background: #F4F7FF;
  padding:10px;
   margin-top: 10px;
  p{
    color:$c6;
    line-height: 32px;
  }
}
</style>
